import type { FC, ReactNode } from "react";

// A polite live region heard by screen readers only. Keep it mounted and
// change its words: a region that appears with its words is not announced.
export const ScreenReaderStatus: FC<{ children?: ReactNode }> = ({
  children,
}) => (
  <span role="status" aria-live="polite" className="sr-only">
    {children}
  </span>
);
